<template>
  <!-- <div class="container heading">
    <div class="row">
      <div class="col-sm-12 col-md-12">
      <div class="item">
        <h3>SECTION OF LEGAL EDUCATION</h3>
      </div>
    </div>
    <div class="col-sm-12 col-md-12">
      <div class="item">
        <h4>The ABA Section of Legal Education and Admissions to the Bar serves, through its Council, as the nationally recognized accrediting body for American legal education, providing a fair law school accrediting system that promotes quality legal education.</h4>
      </div>
    </div>
  </div>
  </div> -->
  <div class="container heading">
    <img src="../assets/bg_image.png" id="homeimage" alt="Background image of the home page">
    <div class="orgName">SECTION OF LEGAL EDUCATION</div>
    <div class="des">The ABA Section of Legal Education and Admissions to the Bar serves, through its Council, as the nationally recognized accrediting body for American legal education, providing a fair law school accrediting system that promotes quality legal education.</div>
    <!-- <h3 class="col-sm-12" id="orgName">SECTION OF LEGAL EDUCATION</h3>
    <h4 class="col-sm-12" id="des">The ABA Section of Legal Education and Admissions to the Bar serves, through its Council, as the nationally recognized accrediting body for American legal education, providing a fair law school accrediting system that promotes quality legal education.</h4> -->
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>

.container {
  position: relative;
  color: white;
}

.heading{
  height: 100%;
}
.orgName{
  position: absolute;
  top: 6vw;
  left: 6vw;
  font-size: 2vw;
  font-weight: 500;
  font: 'Arial';
  color: white;
}
.des{
  position: absolute;
  bottom: 0;
  padding-left: 6vw;
  padding-bottom: 5vw;
  padding-right: 7vw;
  font: 'Arial';
  color: white;
  font-size: 1.8vw;
  font-weight: 500;
  background: rgba(145, 145, 145, 0.5);
}

.col-sm-12{
  padding-bottom: 0;
  margin-bottom: 0;
  padding-right: 0;
  margin-right: 0;
}

img {
/*  width: 100%;
  height: auto;*/
  width:1400px;
  height:624px;
}
</style>
